import type { Resource } from '@medplum/fhirtypes';
import { withTenantScope as _withTenantScope } from '@polarissleep/shared';

const TENANT_ORG_ID: string | undefined = import.meta.env?.VITE_MEDPLUM_ORGANIZATION_ID;

/**
 * Applies `meta.account` to the resource using the tenant Organization ID from env.
 * @param resource
 */
export function withTenantScope<T extends Resource>(resource: T): T {
  return _withTenantScope(resource, TENANT_ORG_ID);
}
